import api from './api';

export interface ClientePrezziPersonalizzati {
  idCliente: number;
  ragioneSociale: string;
  nArticoli: number;
  articoli: { sku: string; descrizione: string; prezzo: number; validoDal?: string; validoAl?: string }[];
}

export interface ArticoloPrezziPersonalizzati {
  sku: string;
  descrizione: string;
  nClienti: number;
  clienti: { idCliente: number; ragioneSociale: string; prezzo: number; validoDal?: string; validoAl?: string }[];
}

export interface ClienteClasseSconto {
  idCliente: number;
  ragioneSociale: string;
  sconto1: number;
  sconto2: number;
}

export interface ArticoloScontoScatola {
  sku: string;
  descrizione: string;
  sconto1: number;
  sconto2: number;
  quantitaDa: number;
  validoDal?: string;
  validoAl?: string;
}

export const adminPricingService = {
  async clientiPrezziPersonalizzati() {
    const { data } = await api.get<{ items: ClientePrezziPersonalizzati[]; total: number }>('/api/admin/pricing/clienti-prezzi-personalizzati');
    return data;
  },
  async articoliPrezziPersonalizzati() {
    const { data } = await api.get<{ items: ArticoloPrezziPersonalizzati[]; total: number }>('/api/admin/pricing/articoli-prezzi-personalizzati');
    return data;
  },
  async clientiClassiSconto() {
    const { data } = await api.get<{ items: ClienteClasseSconto[]; total: number }>('/api/admin/pricing/clienti-classi-sconto');
    return data;
  },
  async articoliScontiScatola() {
    const { data } = await api.get<{ items: ArticoloScontoScatola[]; total: number }>('/api/admin/pricing/articoli-sconti-scatola');
    return data;
  },
};
